import { connect } from 'react-redux'
import { signOutUser } from '../actions'

const NoGroups = (props) => {
    props.signOutUser()
    return null
}

export default connect(null, { signOutUser })(NoGroups)
